<template>
  <v-container v-if="noData">
    <div class="text-xs-center">
    <h2>No recalls found for: {{this.searchString}}</h2>
    </div>
  </v-container>

  <v-container v-else fluid grid-list-md class="recall-container">

    <div v-for="(recallMonths, recallMonthIdx) in recallsByMonth" :key="recallMonthIdx">
      <div class="flex xs12 recall-month-header">{{ recallMonths.date }}</div>

        <v-layout row wrap>
          <v-flex d-flex
            v-for="(item, idx) in recallMonths.recalls"
            v-bind="{ [`xs${flex}`]: true }"
            :key="idx"
            class="pa-2"
          >
            <v-card class="recall-card recall-card-list" hover data-aos="zoom-in" data-aos-easing="ease">
              <v-layout row wrap>
                <v-flex xs4>
                  <v-img
                    class="recall-thumb"
                    height="200px"
                    v-if="Object.keys(item.Images).length > 0"
                    :src="item.Images[0].URL"
                    @click.stop="singleRecall(item.RecallID)"
                  />
                </v-flex>
                <v-flex xs8>
                  <v-card-title>
                      <v-flex text-xs-left class="title recall-title"
                        @click.stop="singleRecall(item.RecallID)"
                        style="cursor: pointer"
                      >{{item.Title}}
                      </v-flex>
                      <v-flex class="body">
                        <div v-if="item.Description.length > 140" class="text-xs-left grey--text recall-description">
                          {{item.Description.substring(0, 140)}}... &nbsp;&nbsp;
                          <router-link :to="{ name: 'RecallDetails', params: { id: item.RecallID }}">read more</router-link>
                        </div>
                        <div v-else class="grey--text recall-description">
                          {{item.Description}} &nbsp;&nbsp;
                        </div>
                      </v-flex>
                  </v-card-title>
                  <v-card-actions class="recall-footer">
                      <v-flex class="footer">
                        <div class="recall-date">
                            {{ formatDate(item.RecallDate) }}
                        </div>
                      <social v-bind:id=item.RecallID v-bind:title=item.Title></social>
                      </v-flex>
                  </v-card-actions>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>

    </div>
  </v-container>
</template>
<script>
import * as moment from 'moment/moment'
// eslint-disable-next-line no-unused-vars
import { groupBy, sortBy, chain } from 'lodash'

export default {
  name: 'ListCards',
  props: ['recalls', 'noData', 'searchString'],
  data () {
    return {
      loading: false
    }
  },
  methods: {
    singleRecall (id) {
      this.$router.push('/recall/' + id)
    },
    formatDate (date) {
      return moment(date).format('MMMM DD, YYYY')
    }
  },
  computed: {
    flex () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return 12
        case 'sm': return 12
        case 'md': return 12
        case 'lg': return 12
        case 'xl': return 12
        default: return 12
      }
    },
    recallsByMonth () {
      // eslint-disable-next-line no-undef
      var result = _.chain(this.recalls)
        .groupBy(d => moment(d.RecallDate).format('MMMM YYYY'))
        .map((recalls, date) => ({ date, recalls })) // using ES6 shorthand to generate the objects
        .sortBy(this.recalls, o => o.RecallDate)
        .value()

      return result
    }
  }
}
</script>

<style scoped>

  .recall-month-header {
    padding-top: 36px !important;
  }

  @media (max-width: 600px) {
    .v-image__image {
      background-size: contain;
    }
  }
</style>
